<template>
    <vx-card v-if="loading">
        <h3>Loading.. Please wait..</h3>
    </vx-card>
    <div v-else>
        <h3 class="mt-2 mb-3" v-if="issue_type == 'highway'">Corrective Maintenance Approval</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'electrical_maintenance'">Electrical Maintenance Approval</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'major_maintenance'">Major Maintenance Approval</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'routine_maintenance'">Routine Maintenance Approval</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'road_user_accident'">Road User Accident Approval</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'occupational'">Occupational Accident Approval</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'hazard'">Hazard Accident Approval</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'dead_animal_debris_removal'">Dead Animal Debris Removal Approval</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'vehicle_breakdown'">Vehicle Breakdown Approval</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'traffic_violation'">Traffic Violation Approval</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'unauthorised_parking'">Unauthorised Parking Approval</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'unauthorised_access'">Unauthorised Access Approval</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'unauthorised_media_cut'">Unauthorised Median Cut Approval</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'material_damage'">Material Damage Approval</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'other'">Other Approval</h3>
        <h3 class="mt-2 mb-3" v-else-if="issue_type == 'enroachment_row'">Enroachment Row Approval</h3>

        <template v-if="showReview">
            <vx-card noShadow noRound>
                <HighwayApprove v-if="issue_type == 'highway'" :allocated_resource_dropdown="allocated_resource_dropdown"
                    :allocated_engineer_dropdown="allocated_engineer_dropdown" :allocated_engineer_external_dropdown="allocated_engineer_external_dropdown"
                    :issue.sync="issue" :api_errors="api_errors" 
                />
                <HazardApprove v-else-if="issue_type == 'hazard'" :allocated_resource_dropdown="allocated_resource_dropdown"
                    :allocated_engineer_dropdown="allocated_engineer_dropdown" :allocated_engineer_external_dropdown="allocated_engineer_external_dropdown"
                    :issue.sync="issue" :api_errors="api_errors" 
                />
                <ElectricalMaintenanceApprove v-else-if="issue_type == 'electrical_maintenance'" :allocated_resource_dropdown="allocated_resource_dropdown"
                    :allocated_engineer_dropdown="allocated_engineer_dropdown" :allocated_engineer_external_dropdown="allocated_engineer_external_dropdown"
                    :issue.sync="issue" :api_errors="api_errors" 
                />
                <MajorMaintenanceApprove v-else-if="issue_type == 'major_maintenance'" :allocated_resource_dropdown="allocated_resource_dropdown"
                    :allocated_engineer_dropdown="allocated_engineer_dropdown" :allocated_engineer_external_dropdown="allocated_engineer_external_dropdown"
                    :issue.sync="issue" :api_errors="api_errors" 
                />
                <RoutineMaintenanceApprove v-else-if="issue_type == 'routine_maintenance'" :allocated_resource_dropdown="allocated_resource_dropdown"
                    :allocated_engineer_dropdown="allocated_engineer_dropdown" :allocated_engineer_external_dropdown="allocated_engineer_external_dropdown" 
                    :issue.sync="issue" :api_errors="api_errors" 
                />
                <RoadUserAccidentApprove v-else-if="issue_type == 'road_user_accident'" :allocated_resource_dropdown="allocated_resource_dropdown"
                    :allocated_engineer_dropdown="allocated_engineer_dropdown" :allocated_engineer_external_dropdown="allocated_engineer_external_dropdown" 
                    :issue.sync="issue" :api_errors="api_errors" 
                />
                <OccupationalApprove v-else-if="issue_type == 'occupational'" :allocated_resource_dropdown="allocated_resource_dropdown"
                    :allocated_engineer_dropdown="allocated_engineer_dropdown" :allocated_engineer_external_dropdown="allocated_engineer_external_dropdown" 
                    :issue.sync="issue" :api_errors="api_errors" 
                />
                <DeadAnimalDebrisRemovalApprove v-else-if="issue_type == 'dead_animal_debris_removal'" :allocated_resource_dropdown="allocated_resource_dropdown"
                    :allocated_engineer_dropdown="allocated_engineer_dropdown" :allocated_engineer_external_dropdown="allocated_engineer_external_dropdown"
                    :issue.sync="issue" :api_errors="api_errors" 
                />
                <VehicleBreakdownApprove v-else-if="issue_type == 'vehicle_breakdown'" :allocated_resource_dropdown="allocated_resource_dropdown"
                    :allocated_engineer_dropdown="allocated_engineer_dropdown" :allocated_engineer_external_dropdown="allocated_engineer_external_dropdown"
                    :issue.sync="issue" :api_errors="api_errors" 
                />
                <TrafficViolationApprove v-else-if="issue_type == 'traffic_violation'" :allocated_resource_dropdown="allocated_resource_dropdown"
                    :allocated_engineer_dropdown="allocated_engineer_dropdown" :allocated_engineer_external_dropdown="allocated_engineer_external_dropdown"
                    :issue.sync="issue" :api_errors="api_errors" 
                />
                <UnauthorisedParkingApprove v-else-if="issue_type == 'unauthorised_parking'" :allocated_resource_dropdown="allocated_resource_dropdown"
                    :allocated_engineer_dropdown="allocated_engineer_dropdown" :allocated_engineer_external_dropdown="allocated_engineer_external_dropdown"
                    :issue.sync="issue" :api_errors="api_errors" 
                />
                <UnauthorisedAccessApprove v-else-if="issue_type == 'unauthorised_access'" :allocated_resource_dropdown="allocated_resource_dropdown"
                    :allocated_engineer_dropdown="allocated_engineer_dropdown" :allocated_engineer_external_dropdown="allocated_engineer_external_dropdown"
                    :issue.sync="issue" :api_errors="api_errors" 
                />
                <UnauthorisedMedianCutApprove v-else-if="issue_type == 'unauthorised_media_cut'" :allocated_resource_dropdown="allocated_resource_dropdown"
                    :allocated_engineer_dropdown="allocated_engineer_dropdown" :allocated_engineer_external_dropdown="allocated_engineer_external_dropdown"
                    :issue.sync="issue" :api_errors="api_errors" 
                />
                <MaterialDamageApprove v-else-if="issue_type == 'material_damage'" :allocated_resource_dropdown="allocated_resource_dropdown"
                    :allocated_engineer_dropdown="allocated_engineer_dropdown" :allocated_engineer_external_dropdown="allocated_engineer_external_dropdown"
                    :issue.sync="issue" :api_errors="api_errors" 
                />
                <OtherApprove v-else-if="issue_type == 'other'" :allocated_resource_dropdown="allocated_resource_dropdown"
                    :allocated_engineer_dropdown="allocated_engineer_dropdown" :allocated_engineer_external_dropdown="allocated_engineer_external_dropdown"
                    :issue.sync="issue" :api_errors="api_errors" 
                />
                <EnroachmentRowApprove v-else-if="issue_type == 'enroachment_row'" :allocated_resource_dropdown="allocated_resource_dropdown"
                    :allocated_engineer_dropdown="allocated_engineer_dropdown" :allocated_engineer_external_dropdown="allocated_engineer_external_dropdown"
                    :issue.sync="issue" :api_errors="api_errors" 
                />
    
                <vs-row class="mt-base">
                    <vs-col class="text-center">
                        <vs-button @click="save" :disabled="submit_disabled">
                            Save
                        </vs-button>
                    </vs-col>
                </vs-row>
            </vx-card>
        </template>
        <template v-else>
            <PermissionDenied />
        </template>
    </div>
</template>

<script>
import { Request } from "../../utils/requests";
import HighwayApprove from "./Highway/HighwayApprove.vue";
import HazardApprove from "./Hazard/HazardApprove.vue";
import ElectricalMaintenanceApprove from "./ElectricalMaintenance/ElectricalMaintenanceApprove.vue";
import MajorMaintenanceApprove from "./MajorMaintenance/MajorMaintenanceApprove.vue";
import RoutineMaintenanceApprove from "./RoutineMaintenance/RoutineMaintenanceApprove.vue";
import RoadUserAccidentApprove from "./RoadUserAccident/RoadUserAccidentApprove.vue";
import OccupationalApprove from "./Occupational/OccupationalApprove.vue";
import DeadAnimalDebrisRemovalApprove from "./DeadAnimalDebrisRemoval/DeadAnimalDebrisRemovalApprove.vue";
import VehicleBreakdownApprove from "./VehicleBreakDown/VehicleBreakdownApprove.vue";
import TrafficViolationApprove from "./TrafficViolation/TrafficViolationApprove.vue";
import UnauthorisedParkingApprove from "./UnauthorisedParking/UnauthorisedParkingApprove.vue";
import UnauthorisedAccessApprove from "./UnauthorisedAccess/UnauthorisedAccessApprove.vue";
import UnauthorisedMedianCutApprove from "./UnauthorisedMedianCut/UnauthorisedMedianCutApprove.vue";
import MaterialDamageApprove from "./MaterialDamage/MaterialDamageApprove.vue";
import OtherApprove from "./Other/OtherApprove.vue";
import EnroachmentRowApprove from "./EnroachmentRow/EnroachmentRowApprove.vue";
import moment from "moment";

export default {
    data() {
        return {
            issue_id: this.$route.params.issue_id,
            issue_type: this.$route.params.issue_type,

            loading: true,

            issue: null,

            submit_disabled: false,
            api_errors: {}
        }
    },
    computed: {
        showReview() {  
            return this.hasAccess('review', `issue_${this.issue_type}`, ['all', 'assigned'], this.issue.assigned_reviewers.map(v=>v.id)) 
        },
    },
    watch: {
        "$route.params.issue_type"(newV, oldV) {
            if (newV == oldV)
                return;
            this.init();
        },
        "$route.params.issue_id"(newV, oldV) {
            if (newV == oldV)
                return;
            this.init();
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.issue_type = this.$route.params.issue_type
            this.issue_id = this.$route.params.issue_id

            if (this.issue_id) this.load_data()
        },
        load_data() {
            let request_method = 'GET', url = this.$store.state.apiendpoints.data_issue + this.issue_id + "/"

            this.$vs.loading()
            this.loading = true

            Request(this, request_method, url).then(
                res => {
                    this.$vs.loading.close()
                    this.loading = false
                    if (res.status != 'p') {
                        return this.$router.push({name: 'issues-list', params: {issue_type: this.issue_type}})
                    }
                    this.issue = res
                    if (!this.issue.resolution_started_on)
                        this.issue.resolution_started_on = moment().format('YYYY-MM-DD')
                },
                err => {
                    this.$vs.loading.close()

                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        save() {
            let payload = {
                action: 'approve',
                allocated_resource: this.issue.allocated_resource,
                allocated_engineer: this.issue.allocated_engineer,
                resource_allocation: this.issue.resource_allocation,
                resolution_started_on: this.issue.resolution_started_on,
                resolution_ended_on: this.issue.resolution_ended_on,
            }

            this.submit_disabled = true
            this.$vs.loading()
            this.api_errors = {}

            Request(this, 'POST', this.sprintf(this.$store.state.apiendpoints.data_issue_action, this.issue.id), null, payload).then(
                () => {
                    this.$vs.loading.close()
                    this.submit_disabled = false

                    this.$router.push({name: 'issues-list', params: {issue_type: this.issue_type}})

                    this.$vs.notify({
                        time: 2500,
                        title: 'Success',
                        text: "Action completed successfully!",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                },
                err => {
                    this.$vs.loading.close()
                    this.submit_disabled = false

                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: 'Please fix the errors and try again!',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "An error occurred while processing your request. Please try again.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        allocated_resource_dropdown() {
            let permission = []
            permission.push(`edit_external_resolution__all__issue_${this.issue_type}`)
            permission.push(`edit_external_resolution__assigned__issue_${this.issue_type}`)

            return permission.toString()
        },
        allocated_engineer_external_dropdown() {
            let permission = []
            permission.push(`review_external_resolution__all__issue_${this.issue_type}`)
            permission.push(`review_external_resolution__assigned__issue_${this.issue_type}`)
            
            return permission.toString()
        },
        allocated_engineer_dropdown() {
            let permission = []
            permission.push(`edit_resolution__all__issue_${this.issue_type}`)
            permission.push(`edit_resolution__assigned__issue_${this.issue_type}`)

            return permission.toString()
        }
    },
    components: { HighwayApprove, HazardApprove, ElectricalMaintenanceApprove, MajorMaintenanceApprove, RoutineMaintenanceApprove,
        RoadUserAccidentApprove, OccupationalApprove, DeadAnimalDebrisRemovalApprove, VehicleBreakdownApprove, TrafficViolationApprove,
        UnauthorisedParkingApprove, UnauthorisedAccessApprove, UnauthorisedMedianCutApprove, MaterialDamageApprove, OtherApprove,
        EnroachmentRowApprove }
}
</script>
